import React from 'react';
import Select, { components } from 'react-select';
import ReactCountryFlag from 'react-country-flag';
import { COUNTRIES } from '../utils/countries';

// Custom option component with flag
const CountryOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <ReactCountryFlag
          countryCode={props.data.code}
          style={{
            fontSize: '1.2em',
            marginRight: '8px'
          }}
        />
        {props.data.label}
      </div>
    </components.Option>
  );
};

// Custom single value component with flag
const CountrySingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <div className="flex items-center">
        <ReactCountryFlag
          countryCode={props.data.code}
          style={{
            fontSize: '1.2em',
            marginRight: '8px'
          }}
        />
        {props.data.label}
      </div>
    </components.SingleValue>
  );
};

// Main CountrySelect component
const CountrySelect = ({ value, onChange, placeholder = "Select country...", required = false, isClearable = false, ...props }) => {
  const selectedCountry = COUNTRIES.find(country => country.value === value) || null;

  return (
    <Select
      options={COUNTRIES}
      value={selectedCountry}
      onChange={(selectedOption) => onChange(selectedOption ? selectedOption.value : '')}
      placeholder={placeholder}
      className="react-select-container"
      classNamePrefix="react-select"
      isSearchable
      isClearable={isClearable}
      components={{
        Option: CountryOption,
        SingleValue: CountrySingleValue
      }}
      filterOption={(option, inputValue) => {
        if (!option.data || !inputValue) return true;
        const label = option.data.label || '';
        const code = option.data.code || '';
        const input = inputValue || '';
        return (
          label.toLowerCase().includes(input.toLowerCase()) ||
          code.toLowerCase().includes(input.toLowerCase())
        );
      }}
      {...props}
    />
  );
};

export default CountrySelect;